@if (loaderService.loading$ | async; as loading) {
  <ng-container data-testid="global-loader">
    @if (loading.open) {
      <div class="loader-container" [ngClass]="{ 'half-background': loading.type === 'half' }">
        <div class="loader-content">
          <img
            class="loader-logo"
            src="https://static.soregies.fr/logos/Groupe+Sore%CC%81gies/Symboles+Groupe+Soregies/Vert/Symbole+Soregies.svg"
          />
        </div>
      </div>
    }
  </ng-container>
}
